var _style, _g, _defs, _path, _defs2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 19 25"
    },
    viewBox: "0 0 19 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "Web-Scanner-Designs-Rebuild"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LWS_v3_Help-Landing",
    transform: "translate(-32 -550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q",
    transform: "translate(27 545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_x2F_stroke_x2F_ui_x2F_contact-phone",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.388 2.694)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    d: "M13.1 24c-.4 0-.7-.2-.9-.6-.2-.5.1-1 .6-1.1l2.8-.9c.4-.1.6-.5.6-.6 0-.1.1-.5-.2-.8l-2.7-2.7c-.2-.2-.5-.3-.8-.2l-2.3.5c-.2.1-.5 0-.7-.1-.1-.1-2.1-1.3-3.3-3.4S4.8 9.4 4.8 9.3c0-.2.1-.5.2-.6L6.7 7c.2-.3.3-.6.2-.9l-1-3.7c-.1-.4-.4-.5-.6-.6-.1 0-.5-.1-.8.2L2.3 4c-.4.2-.5.6-.5 1 .1 2 .6 6 2.8 9.8 1.7 2.9 3.9 4.9 5.5 6.2.4.3.5.9.2 1.3s-.9.5-1.3.2c-1.7-1.3-4.2-3.6-6-6.7C.6 11.6.1 7.3 0 5.1c0-1 .3-1.9 1.1-2.5L3.3.7C4 .1 4.9-.2 5.8.1c.9.3 1.6 1 1.8 1.9l1 3.7c.2.9 0 1.9-.6 2.5L6.6 9.6c.1.7.3 2.1 1 3.4.7 1.3 1.9 2.2 2.4 2.6l1.9-.4c.9-.2 1.9 0 2.5.7l2.7 2.7c.7.7.9 1.6.7 2.5-.1.9-.8 1.6-1.6 1.9l-2.8.9c-.1.1-.2.1-.3.1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    width: 29,
    height: 29,
    x: -5.4,
    y: -2.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_1_",
    width: 29,
    height: 29,
    x: -5.4,
    y: -2.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_2_",
    d: "M13.1 24c-.4 0-.7-.2-.9-.6-.2-.5.1-1 .6-1.1l2.8-.9c.4-.1.6-.5.6-.6 0-.1.1-.5-.2-.8l-2.7-2.7c-.2-.2-.5-.3-.8-.2l-2.3.5c-.2.1-.5 0-.7-.1-.1-.1-2.1-1.3-3.3-3.4S4.8 9.4 4.8 9.3c0-.2.1-.5.2-.6L6.7 7c.2-.3.3-.6.2-.9l-1-3.7c-.1-.4-.4-.5-.6-.6-.1 0-.5-.1-.8.2L2.3 4c-.4.2-.5.6-.5 1 .1 2 .6 6 2.8 9.8 1.7 2.9 3.9 4.9 5.5 6.2.4.3.5.9.2 1.3s-.9.5-1.3.2c-1.7-1.3-4.2-3.6-6-6.7C.6 11.6.1 7.3 0 5.1c0-1 .3-1.9 1.1-2.5L3.3.7C4 .1 4.9-.2 5.8.1c.9.3 1.6 1 1.8 1.9l1 3.7c.2.9 0 1.9-.6 2.5L6.6 9.6c.1.7.3 2.1 1 3.4.7 1.3 1.9 2.2 2.4 2.6l1.9-.4c.9-.2 1.9 0 2.5.7l2.7 2.7c.7.7.9 1.6.7 2.5-.1.9-.8 1.6-1.6 1.9l-2.8.9c-.1.1-.2.1-.3.1",
    className: "st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour-_x2F_-primary-_x2F_-19-grey---_x23_1C1F21",
    style: {
      mask: "url(#mask-2_1_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M29 0v29H0V0",
    style: {
      fill: "#1c1f21"
    },
    transform: "translate(-5.388 -2.694)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask-2",
    transform: "translate(13.92 2.694)"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    width: 29,
    height: 29,
    x: -13.9,
    y: -2.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4_1_",
    width: 29,
    height: 29,
    x: -13.9,
    y: -2.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_1_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-3_2_",
    d: "M2 5.9c-.2 0-.5-.1-.6-.3-.2-.4-.1-.8.3-1 .1-.1 1.1-.7.8-1.9C2.1 1.5.9 1.5.8 1.5.4 1.5.1 1.2.1.8.1.4.4.1.7.1c.8 0 2.5.4 3 2.1.5 1.8-.7 3-1.4 3.4-.1.2-.2.3-.3.3",
    className: "st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour-_x2F_-primary-_x2F_-11-white---_x23_FFFFFF",
    style: {
      mask: "url(#mask-4_1_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_",
    d: "M29 0v29H0V0",
    className: "st1",
    transform: "translate(-13.92 -2.694)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.6565934e2be0b3b6c8e324e2b699e3c0.svg";
export { ForwardRef as ReactComponent };